import styled from 'styled-components';
import { clearTextFieldStyles } from './css';

export const ClearInput = styled.input`
  ${clearTextFieldStyles};

  text-overflow: ellipsis;
  border-radius: 0;

  &:focus {
    background-color: transparent;
  }
`;

export default ClearInput;
